module.exports = __webpack_public_path__ + "static/media/Sahary.717373ec.md";